<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
    >
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          large
          block
        >
          Original Payment Schedule
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Original Payment Schedule
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="formattedPaymentSchedules"
            :items-per-page="10"
            class="elevation-1"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { formatDate } from '@/services/HelperService';

export default {
  name: 'PaymentSchedule',
  props: {
    loanId: {
      type: Number,
      required: false,
      default: null,
    },
    loanType: {
      type: String,
      required: false,
      default: 'installment',
    },
  },
  data() {
    let tableHeaders = [
      { title: 'Title', key: 'title' },
      { title: 'Principal Balance', key: 'principal_balance' },
      { title: 'charge amount', key: 'charge_amount' },
      { title: 'adb', key: 'adb' },
      { title: 'adb days', key: 'adb_days' },
      { title: 'Period', key: 'period' },
      { title: 'Period Start', key: 'period_start' },
      { title: 'Period End', key: 'period_end' },
      { title: 'Date', key: 'date' },
      { title: 'Last updated', key: 'lastUpdated' },
    ];

    if (this.loanType !== 'loan.type.installment') {
      tableHeaders = [
        { title: 'Title', key: 'display_id' },
        { title: 'Balacne', key: 'new_balance' },
        { title: 'Payment Amount', key: 'payment_amount' },
        { title: 'Fee Amount', key: 'fee_amount' },
        { title: 'adb', key: 'adb' },
        { title: 'Days in Cycle', key: 'days_in_cycle' },
        { title: 'Period Start', key: 'period_start' },
        { title: 'Period End', key: 'period_end' },
        { title: 'Date', key: 'created_at' },
        { title: 'Updated', key: 'updated_at' },

      ];
    }

    return {
      dialog: false,
      headers: tableHeaders,
    };
  },
  computed: {
    ...mapState('loanProLoan', ['paymentSchedules']),

    formattedPaymentSchedules() {
      return (this.paymentSchedules || []).map((pSchedule) => ({
        ...pSchedule,
        period_start: formatDate(pSchedule.period_start),
        period_end: formatDate(pSchedule.period_end),
        created_at: formatDate(pSchedule.created_at),
        updated_at: formatDate(pSchedule.updated_at),
        date: formatDate(pSchedule.date),
        lastUpdated: formatDate(pSchedule.lastUpdated),
      }));
    },
  },
};
</script>
